const inr = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2 });
const inrWhole = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

/** 18500 becomes "₹18,500.00" */
export const formatINR = (n, { whole = false } = {}) => (n == null || Number.isNaN(+n) ? '₹ 0.00' : (whole ? inrWhole : inr).format(+n));

/** Groups digits the Indian way without the symbol: 2500000 becomes "25,00,000" */
export const groupIN = (n) => (n === '' || n == null ? '' : new Intl.NumberFormat('en-IN').format(+n));

/** Date, ISO string or epoch ms becomes "12 Sept 2026" */
export const formatDate = (d) => {
  const x = new Date(d);
  return `${x.getDate()} ${months[x.getMonth()]} ${x.getFullYear()}`;
};

/** "12 Sept 2026, 4:05 pm" */
export const formatDateTime = (d) => {
  const x = new Date(d);
  const h = x.getHours();
  const m = String(x.getMinutes()).padStart(2, '0');
  return `${formatDate(x)}, ${h % 12 || 12}:${m} ${h < 12 ? 'am' : 'pm'}`;
};

/** Account or card number becomes "•••• 2048" */
export const mask = (v) => `•••• ${String(v).slice(-4)}`;

/** Legacy id "transaction_details_1581263787650" becomes "TD1581263787650" */
export const txnRef = (id) => (String(id).startsWith('transaction_details_') ? `TD${String(id).split('_').pop()}` : id);
